module.exports = __webpack_public_path__ + "static/media/chatcord.762ad694.webp";